var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Alert',{staticClass:"mt-6",attrs:{"message":_vm.$t('errorMessages.cannotAccessPage'),"type":"error"}}),_vm._v(" "),_c('Search',{staticClass:"search mt-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }